import { useData } from "../utils/useData";
import { CommunicationBanner } from "./CommunicationBanner";
import { useMarkCommunicationRead } from "../hooks/communications/useMarkCommunicationRead";

export const CommunicationsBanners = () => {
  const { communications } = useData();

  const markCommunicationRead = useMarkCommunicationRead();

  return (
    <>
      {communications.data?.items
        .filter((c) => !c.isRead)
        .map((c) => {
          return (
            <CommunicationBanner
              communication={c}
              markRead={(communicationId: string) =>
                markCommunicationRead.mutate(communicationId)
              }
            />
          );
        })}
    </>
  );
};
